import { render, staticRenderFns } from "./ScoreQuery.vue?vue&type=template&id=73a4142e&scoped=true"
import script from "./ScoreQuery.vue?vue&type=script&lang=js"
export * from "./ScoreQuery.vue?vue&type=script&lang=js"
import style0 from "./ScoreQuery.vue?vue&type=style&index=0&id=73a4142e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a4142e",
  null
  
)

export default component.exports